var chunkMapping = {
	"webpack_container_remote_hlContentDesigner_CMSEditorContainer": [
		"webpack/container/remote/hlContentDesigner/CMSEditorContainer"
	],
	"src_Calendar_Calendar_tsx": [
		"webpack/container/remote/hlReactRootLegacy/CalendarContainer"
	],
	"src_Poll_Poll_tsx": [
		"webpack/container/remote/hlReactRootLegacy/PollTakingContainer"
	],
	"webpack_container_remote_hlReactRootLegacy_AdminPollContainer": [
		"webpack/container/remote/hlReactRootLegacy/AdminPollContainer"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/hlContentDesigner/CMSEditorContainer": [
		"default",
		"./CMSEditorContainer",
		"webpack/container/reference/hlContentDesigner"
	],
	"webpack/container/remote/hlReactRootLegacy/CalendarContainer": [
		"default",
		"./CalendarContainer",
		"webpack/container/reference/hlReactRootLegacy"
	],
	"webpack/container/remote/hlReactRootLegacy/PollTakingContainer": [
		"default",
		"./PollTakingContainer",
		"webpack/container/reference/hlReactRootLegacy"
	],
	"webpack/container/remote/hlReactRootLegacy/AdminPollContainer": [
		"default",
		"./AdminPollContainer",
		"webpack/container/reference/hlReactRootLegacy"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}